import { lazy } from "react";
import { createFileRoute } from "@tanstack/react-router";
import { seoHeadFromPage } from "@/config/seoHead";
import { scrapedPageQueryOptions } from "@/hooks/useScrapedPage";
import { lookupSlug, notFoundUnlessRedirected } from "@/lib/slugGuards";
import { SPOT_PRICE_ARTICLE_PATHS, spotPriceLoader } from "@/lib/spotSnapshot";

const ArtikelDetalj = lazy(() => import("@/pages/content/ArtikelDetalj"));

export const Route = createFileRoute("/blogg/$slug")({
  // Ladda innehållet i SSR så sidan inte hoppar till efter hydrering.
  loader: async ({ params, context }) => {
    const path = `/blogg/${params.slug}`;
    const [page, { spotSnapshot }, related] = await Promise.all([
      lookupSlug(() => context.queryClient.ensureQueryData(scrapedPageQueryOptions(path))),
      SPOT_PRICE_ARTICLE_PATHS.has(path) ? spotPriceLoader() : Promise.resolve({ spotSnapshot: null }),
      // Relaterade artiklar i samma kategori – i server-HTML:en.
      import("@/lib/relatedPagesLoader").then((m) => m.loadRelatedPages(context.queryClient, "blogg", path)).catch(() => null),
    ]);
    // null = artikeln finns inte (404); undefined = uppslagningen misslyckades, rendera ändå.
    if (page === null) await notFoundUnlessRedirected(path);
    return { page, spotSnapshot, related };
  },
  head: ({ params, loaderData }) =>
    seoHeadFromPage(`/blogg/${params.slug}`, loaderData?.page, { ogType: "article" }),
  component: BloggDetaljRoute,
});

function BloggDetaljRoute() {
  const { page, related } = Route.useLoaderData();
  return <ArtikelDetalj initialPage={page} initialRelated={related} />;
}
